export default __webpack_public_path__ + "static/media/W51Living.42f38732.jpg";